import { useEffect, useState } from 'react';
import axios from 'axios';
import { storageUnits as fallbackUnits } from '../data/mockData';

const API_BASE = process.env.REACT_APP_BACKEND_URL ?? '';

// Запасные UI-метаданные на случай, если у типа в админке ещё не заполнены
// «что поместится» / «популярный». Когда поля заданы в админке — берём из API.
const META = {
  XS:  { fits: ['2-3 коробки', 'Велосипед', 'Шины'],                 popular: false },
  S:   { fits: ['5-7 коробок', 'Диван', 'Холодильник'],              popular: false },
  M:   { fits: ['Однокомнатная квартира', 'Офисная мебель'],         popular: true  },
  L:   { fits: ['Двухкомнатная квартира', 'Товарный запас'],         popular: false },
  XL:  { fits: ['Трёхкомнатная квартира', 'Склад интернет-магазина'], popular: false },
  XXL: { fits: ['Загородный дом', 'Коммерческое хранение'],          popular: false },
};

// Маппим ответ /api/box-types в формат, ожидаемый компонентами (storageUnits-shape)
function mapBoxType(bt, idx) {
  const meta = META[bt.code] || { fits: [], popular: false };
  // fits/popular/image теперь приходят из API (редактируются в админке);
  // если ещё не заполнены — используем запасные META по коду.
  const fits = (Array.isArray(bt.fits) && bt.fits.length) ? bt.fits : meta.fits;
  const popular = (bt.popular === 1 || bt.popular === true) ? true
                : (bt.popular === 0 || bt.popular === false) ? false
                : meta.popular;
  return {
    id: idx + 1,
    code: bt.code,
    name: bt.name,
    size: `${bt.size_m2} м²`,
    sizeM2: bt.size_m2,
    volume: `${bt.volume_m3} м³`,
    volumeM3: bt.volume_m3,
    dimensions: bt.dimensions,
    price: bt.price_month,
    available: true,
    popular,
    description: bt.description || '',
    fits,
    image: bt.image || '/images/storage-4.jpg',
  };
}

// Модульный кеш, чтобы 4 компонента не делали 4 одинаковых запроса
let _cache = null;
let _inflight = null;

export async function fetchBoxTypes() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = axios
    .get(`${API_BASE}/api/box-types`)
    .then((r) => {
      const arr = Array.isArray(r.data) ? r.data : [];
      _cache = arr.map(mapBoxType);
      return _cache;
    })
    .catch(() => {
      _cache = fallbackUnits;
      return _cache;
    })
    .finally(() => { _inflight = null; });
  return _inflight;
}

export default function useBoxTypes() {
  const [boxes, setBoxes] = useState(() => _cache || fallbackUnits);
  const [loading, setLoading] = useState(() => !_cache);

  useEffect(() => {
    let mounted = true;
    if (!_cache) {
      fetchBoxTypes().then((data) => { if (mounted) { setBoxes(data); setLoading(false); } });
    } else {
      setLoading(false);
    }
    return () => { mounted = false; };
  }, []);

  return { boxes, loading };
}
